// src/components/TwoColumnLayout.tsx
import React from "react";
import { useEffect, useRef, useState } from "react";

type Props = {
  left: React.ReactNode;   // 미리보기
  right: React.ReactNode;  // 입력 폼
};

export default function TwoColumnLayout({ left, right }: Props) {
  const rightRef = useRef<HTMLDivElement>(null);
  const [rightHeight, setRightHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!rightRef.current) return;

    // ResizeObserver로 오른쪽 높이 추적
    const observer = new ResizeObserver(([entry]) => {
      setRightHeight(entry.contentRect.height);
    });
    observer.observe(rightRef.current);

    // 초기 세팅
    setRightHeight(rightRef.current.offsetHeight);

    return () => observer.disconnect();
  }, []);

  return (
    <div style={styles.container}>
      {/* 왼쪽: max-height를 오른쪽과 동일하게, 넘치면 스크롤 */}
      <div style={{ ...styles.left, maxHeight: rightHeight, overflowY: "auto" }}>
        {left}
      </div>

      {/* 오른쪽: 참조용 ref 달기 */}
      <div ref={rightRef} style={styles.right}>
        {right}
      </div>
    </div>
  );
}


const styles = {
  container: {
    display: "flex",
    gap: "2rem",
    /* 화면이 작아지면 세로 스택 */
    flexWrap: "wrap" as const,
  },
  left: {
    flex: 6,                // 2:1 비율
    minWidth: "600px",
    // 미리보기를 감싸는 앱 크롬(문서 렌더 영역 자체는 건드리지 않음)
    border: "1px solid #E4E7EA",
    borderRadius: "12px",
    boxShadow: "0 1px 2px rgba(16,24,32,0.06)",
    padding: "1rem",
    background: "#FFFFFF",
  },
  right: {
    flex: 4,
    minWidth: "400px",
  },
};
